var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 40,
    viewBox: "0 0 25 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00263E",
    fillRule: "nonzero",
    d: "m24.656 10.265-6.348-7.362a1.15 1.15 0 0 0-.874-.403H1.401C.658 2.5.055 3.113.055 3.868v32.154c0 .756.603 1.368 1.346 1.368h22.198c.744 0 1.346-.613 1.346-1.368V11.045c0-.287-.103-.564-.289-.78M1.401 36.077V3.868h15.584v7c0 .378.3.685.673.685h5.941l.001 24.524z"
  })));
};
export default SvgDefault;